import setupAmpSRSegmentWrapper from '@amplitude/segment-session-replay-wrapper'

// docs: https://amplitude.com/docs/session-replay/session-replay-standalone-sdk

const API_KEY = '77b2c07a269faa404a9d2a4cf2284077'

export const initSessionReplay = async () => {
  const segmentAnalytics = (window as any).analytics
  if (!segmentAnalytics) {
    return
  }

  await setupAmpSRSegmentWrapper({
    segmentInstance: segmentAnalytics,
    amplitudeApiKey: API_KEY,
    sessionReplayOptions: {
      sampleRate: 1,
    },
  })
}
